import AppBarAdmin from "../../components/AppBarAdmin";
import Table from "../../components/Table";
import { createAnalise, deleteAnalise, getAnalises, updateAnalise } from "../../services/analisesService";

export default function Analises() {
    return (
        <>
            <AppBarAdmin title="Análises" />
            <Table 
                loadData={getAnalises} 
                createItem={createAnalise}
                updateItem={updateAnalise}
                deleteItem={deleteAnalise}
                titulo="Análises" 
            />
        </>
    )
}